<template>
    <v-main>
        <v-row class="ma-0">
            <v-col sm="6" class="d-flex align-end justify-end pb-5 pr-5">
                <strong class="white--text">&copy; {{ new Date().getFullYear() }} TCO TEAM.</strong>
            </v-col>
            <v-col sm="6" class="d-flex justify-center align-center">
                <section class="d-flex flex-column align-center">
<!--                    <router-link :to="{name : 'Home'}">-->
<!--                        <img :src="require('@/../public/images/TcoTeam.png')">-->
<!--                    </router-link>-->

                    <h1>{{$t("auth.welcome")}} {{APP_NAME}}</h1>

                    <p>{{$t("auth.description")}}</p>

                    <section class="sectionForm">
                        <ValidationObserver ref="form" v-slot="{ handleSubmit }">
                            <v-form @submit.prevent="handleSubmit(submit)">
                                <ValidationProvider :name="$t('auth.name')" :rules="{required: true, max: 80, regex: /[\u0530-\u058F,a-zA-Z]/}" v-slot="{ errors }">
                                    <v-text-field :label="$t('auth.name')"
                                                  v-model="register.name"
                                    >
                                        <template v-slot:prepend-inner>
                                            <svg v-svg="'icon-name'" size="15" class="mr-1"></svg>
                                        </template>
                                    </v-text-field>
                                    <small class="font-weight-bold error--text">{{ errors[0] }}</small>
                                </ValidationProvider>

                                <ValidationProvider :name="$t('auth.surname')" :rules="{required: true, max: 80, regex: /[\u0530-\u058F,a-zA-Z]/}" v-slot="{ errors }">
                                    <v-text-field :label="$t('auth.surname')"
                                                  v-model="register.sur_name"
                                    >
                                        <template v-slot:prepend-inner>
                                            <svg v-svg="'icon-name'" size="15" class="mr-1"></svg>
                                        </template>
                                    </v-text-field>
                                    <small class="font-weight-bold error--text">{{ errors[0] }}</small>
                                </ValidationProvider>

                                <ValidationProvider vid="phone" :name="$t('auth.phone')" :rules="{required : true, regex: /([0][1|3-9]{2})([0-9]{6})/, max: 9}" v-slot="{ errors }">
                                    <v-text-field :label="$t('auth.phone')"
                                                  v-model="register.phone"
                                    >
                                        <template v-slot:prepend-inner>
                                            <svg v-svg="'icon-phone'" size="15" class="mr-1"></svg>
                                        </template>
                                    </v-text-field>
                                    <small class="font-weight-bold error--text">{{ errors[0] }}</small>
                                </ValidationProvider>

                                <ValidationProvider vid="email" :name="$t('auth.email')" rules="required|email" v-slot="{ errors }">
                                    <v-text-field :label="$t('auth.email')"
                                                  type="email"
                                                  v-model="register.email"
                                    >
                                        <template v-slot:prepend-inner>
                                            <svg v-svg="'icon-email'" size="15" class="mr-1"></svg>
                                        </template>
                                    </v-text-field>
                                    <small class="font-weight-bold error--text">{{ errors[0] }}</small>
                                </ValidationProvider>

                                <v-menu ref="menu"
                                        v-model="menu"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="auto"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <ValidationProvider :name="$t('auth.birth')" rules="required" v-slot="{ errors }">
                                            <v-text-field :value="register.date_of_birth"
                                                          :label="$t('auth.birth')"
                                                          readonly
                                                          v-bind="attrs"
                                                          v-on="on"
                                                          :loading="loadingRequest"
                                            >
                                                <template v-slot:prepend-inner>
                                                    <svg v-svg="'icon-date'" size="15" class="mr-1"></svg>
                                                </template>
                                            </v-text-field>
                                            <small class="font-weight-bold error--text">{{ errors[0] }}</small>
                                        </ValidationProvider>
                                    </template>

                                    <v-date-picker :active-picker.sync="activePicker"
                                                   v-model="register.date_of_birth"
                                                   @change="$refs.menu.save($event)"
                                                   :max="moment(new Date()).subtract(0, 'years').toISOString()"
                                                   :min="moment(new Date()).subtract(60, 'years').toISOString()"
                                                   color="green"
                                    ></v-date-picker>
                                </v-menu>

                                <v-card-actions class="justify-center mt-7">
                                    <v-btn class="white--text" color="green" type="submit" :loading="loadingRequest" width="90" height="30">{{$t("auth.register")}}</v-btn>
                                </v-card-actions>
                            </v-form>
                        </ValidationObserver>
                    </section>

                    <p class="my-7">{{$t("auth.iHave")}}
                        <router-link :to="{name : 'Login'}" class="green--text">
                            {{$t("auth.login")}}
                        </router-link>
                    </p>
                </section>

                <v-footer fixed class="d-none transparent mb-3">
                    <strong class="mx-auto">&copy; {{ new Date().getFullYear() }} TCO TEAM.</strong>
                </v-footer>
            </v-col>
        </v-row>
    </v-main>
</template>

<script>
    export default {
        data(){
            return {
                register: {},
                loadingRequest : false,
                menu: false,
                activePicker: null,
            }
        },

        watch: {
            menu (val) {
                val && setTimeout(() => (this.activePicker = 'YEAR'))
            },
        },

        methods: {
            submit() {
                this.loadingRequest = true;
                this.$api('auth').register(this.register)
                    .then((res) => {
                        this.register = {};
                        this.$store.dispatch('alert', {type: 1, message: res.data.message})
                        this.$refs.form.reset();
                    }).catch((err) => {
                    if (err.response.status === 422) this.$refs.form.setErrors(err.response.data);
                }).finally(() => {
                    this.loadingRequest = false;
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../scss/pages/auth";
</style>